export const partnersActions = {
  populatePartners: "POPULATE_PARTNERS",
  partnersLoadError: "PARTNERS_LOAD_ERROR"
};
